<div class="details-panel clickable" (click)='onClick()' *ngIf='expandable ; else not_expandable'>
  <sfc-icon name="rds-icon-chevron-down" class='expandable' [ngClass]="{'open-button': expanded}" size="xs"></sfc-icon>
  <span class="header-text" [ngClass]="{'open-text': expanded}" >{{title}}</span>
</div>
<ng-template #not_expandable>
  <div class="details-panel">
    <span class="header-text not-expandable">{{title}}</span>
  </div>
</ng-template>

<span [hidden]="!expanded">
   <div [hidden]="hideErrorText" [ngClass]="{'error-text': !hideErrorText}">
    {{errorText}}
   </div>
  <div class="details-name-value-pairs">
    <ng-container  #field_name_and_value_pair></ng-container>
  </div>
  <div class="sub-panel">
    <ng-container  #sub_panel>
    </ng-container>
  </div>
   <div class="detail-table">
    <ng-container  #table></ng-container>
  </div>
  <div class="sub-panel">
    <ng-container  #sub_panel2>
    </ng-container>
  </div>
  <div class="detail-table">
    <ng-container  #table2></ng-container>
  </div>
</span>
